import script from "./BatchCancelDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./BatchCancelDialog.vue?vue&type=script&setup=true&lang=js"

import "./BatchCancelDialog.vue?vue&type=style&index=0&id=27477885&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27477885"]])

export default __exports__